import dayjs from "dayjs"

export type ScheduleMap<Op> = Record<string, Op[]>

export const operationListToSchedule = <Op extends { cleaningDate: string }>(
    data: Op[]
) => {
    const sorted = data.sort(
        (a, b) => dayjs(a.cleaningDate).unix() - dayjs(b.cleaningDate).unix()
    )
    return sorted.reduce(
        (prev: ScheduleMap<Op>, current: Op): ScheduleMap<Op> => {
            const currentData = dayjs(current.cleaningDate).format("YYYYMMDD")
            if (currentData in prev) {
                return {
                    ...prev,
                    [currentData]: [...prev[currentData], current]
                }
            } else {
                return { ...prev, [currentData]: [current] }
            }
        },
        {}
    )
}

export const countSchedule = <Op>(schedule: ScheduleMap<Op>): number => {
    let count = 0
    Object.keys(schedule).forEach(key => {
        count += schedule[key].length
    })
    return count
}
